import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

function Truck({
  variant = "linear",
  color = "primary",
  width = 24,
  height = 24,
}) {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return {
    linear: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 22 22"
      >
        <path
          stroke={colorValue}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.322"
          d="M10.576 12.34h.882c.97 0 1.763-.793 1.763-1.763V1.763H5.288A3.522 3.522 0 002.212 3.57"
        />
        <path
          stroke={colorValue}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.322"
          d="M1.763 14.984a2.64 2.64 0 002.644 2.644h.881c0-.97.794-1.763 1.763-1.763.97 0 1.763.794 1.763 1.763h3.526c0-.97.793-1.763 1.762-1.763.97 0 1.763.794 1.763 1.763h.882a2.64 2.64 0 002.644-2.644V12.34h-2.644a.884.884 0 01-.882-.882V8.814c0-.485.397-.881.882-.881h1.137l-1.508-2.636a1.777 1.777 0 00-1.533-.89H13.22v6.17c0 .97-.793 1.763-1.763 1.763h-.881"
        />
        <path
          stroke={colorValue}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.322"
          d="M7.051 19.391a1.763 1.763 0 100-3.526 1.763 1.763 0 000 3.526zM14.103 19.391a1.763 1.763 0 100-3.526 1.763 1.763 0 000 3.526zM19.39 10.577v1.763h-2.643a.884.884 0 01-.882-.882V8.814c0-.485.397-.881.882-.881h1.137l1.507 2.644zM1.763 7.051H7.05M1.763 9.696h3.525M1.763 12.34h1.763"
        />
      </svg>
    ),
  }[variant];
}

export default Truck;
